import React from 'react';

import { Icon, Tooltip } from '@atom/mui';
import colors from '@atom/styles/colors';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './taskItemTile.module.css';

interface Props {
  content: string;
  contentColor?: string;
  tooltipContent?: string;
  onTileClick?: (event: any) => void;
  icon: React.ReactNode;
  actionButton?: React.ReactNode;
  // maxWidth can be used to set a max-width for the tile.
  // Content that exceeds the width will be shortened with ellipsis
  // And fully rendered in a hover tooltip
  maxWidth?: string;
  containerStyles?: any;
  hasError?: boolean;
}

const TaskItemTile = ({
  content,
  contentColor = colors.neutral.dim,
  tooltipContent,
  onTileClick = () => {},
  icon,
  actionButton = <div />,
  maxWidth,
  containerStyles = {},
  hasError = false,
}: Props) => {
  const containerStyle = maxWidth ? { ...containerStyles, maxWidth } : {};
  const contentStyle = { color: hasError ? colors.brand.red : contentColor };

  return (
    <div style={containerStyle} className={classes.tileContainer}>
      {hasError ? (
        <Icon onClick={onTileClick} color={colors.brand.red}>
          error_outline
        </Icon>
      ) : (
        <div onClick={onTileClick}>{icon}</div>
      )}
      <Tooltip
        disableHoverListener={isNilOrEmpty(tooltipContent)}
        title={tooltipContent || ''}
      >
        <div
          style={contentStyle}
          className={classes.content}
          onClick={onTileClick}
        >
          {content}
        </div>
      </Tooltip>
      {actionButton}
    </div>
  );
};

export default TaskItemTile;
